import React from "react";
import { motion } from "framer-motion";
import { FaAws, FaGoogle, FaPython, FaJava, FaDocker } from "react-icons/fa";
import { SiKubernetes, SiTerraform, SiMongodb } from "react-icons/si";

const timelineData = [
  {
    year: "2014",
    title: "Started with Python & Java",
    icon: <FaPython />,
    description:
      "Began my programming journey by mastering Python and Java, learning the fundamentals of object-oriented programming.",
    color: "from-yellow-400 to-orange-400",
  },
  {
    year: "2016",
    title: "Explored Cloud Technologies",
    icon: <FaAws />,
    description:
      "Gained expertise in AWS and started building scalable applications using cloud infrastructure.",
    color: "from-orange-400 to-red-400",
  },
  {
    year: "2018",
    title: "Mastered Docker & Kubernetes",
    icon: <FaDocker />,
    description:
      "Dove deep into containerization and orchestration with Docker and Kubernetes, creating cloud-native applications.",
    color: "from-blue-400 to-cyan-400",
  },
  {
    year: "2020",
    title: "Expanded into Google Cloud & Terraform",
    icon: <FaGoogle />,
    description:
      "Learned Google Cloud and Terraform to automate cloud deployments and infrastructure provisioning.",
    color: "from-green-400 to-blue-400",
  },
  {
    year: "2021",
    title: "Adopted Kubernetes Security Practices",
    icon: <SiKubernetes />,
    description:
      "Focused on securing Kubernetes environments, implementing advanced security best practices for cloud-native platforms.",
    color: "from-purple-400 to-pink-400",
  },
  {
    year: "2022",
    title: "Advanced with Security practices",
    icon: <SiMongodb />,
    description:
      "Worked extensively with MongoDB and NoSQL databases, optimizing data storage for large-scale cloud applications.",
    color: "from-green-400 to-emerald-400",
  },
];

const SkillsTimeline = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <motion.h2
        className="text-3xl sm:text-4xl font-bold text-center mb-12 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Skills Development Timeline
      </motion.h2>

      <div className="relative">
        {/* Timeline line */}
        <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-gradient-to-b from-blue-400 via-purple-400 to-pink-400 hidden sm:block"></div>

        <div className="space-y-12">
          {timelineData.map((event, index) => (
            <motion.div
              key={index}
              className={`flex flex-col sm:flex-row items-center justify-between ${index % 2 === 0 ? "sm:flex-row-reverse" : ""}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              {/* Timeline Card */}
              <div className="w-full sm:w-5/12">
                <motion.div
                  className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-xl shadow-xl hover:bg-white/10 transition-all duration-300"
                  whileHover={{ scale: 1.02 }}
                >
                  <div
                    className={`text-4xl mb-4 bg-gradient-to-r ${event.color} bg-clip-text text-transparent`}
                  >
                    {event.icon}
                  </div>
                  <h3 className="text-xl font-semibold mb-2 text-white">
                    {event.title}
                  </h3>
                  <p className="text-gray-300">{event.description}</p>
                </motion.div>
              </div>

              {/* Year Marker */}
              <div className="w-full sm:w-2/12 text-center my-4 sm:my-0">
                <motion.div
                  className={`bg-gradient-to-r ${event.color} p-4 rounded-full w-20 h-20 mx-auto flex items-center justify-center shadow-lg`}
                  whileHover={{ scale: 1.1, rotate: 360 }}
                  transition={{ duration: 0.5 }}
                >
                  <p className="font-bold text-lg text-white">{event.year}</p>
                </motion.div>
              </div>

              {/* Empty space for alignment */}
              <div className="hidden sm:block sm:w-5/12"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkillsTimeline;
